import { selectorFamily } from 'recoil';
import APIService from '../../APIService';
import { Apis } from '../../app.constants';
import { entityDetailsStateAtomFamily } from './entity.ts';
// import { entityDetailsStateAtomFamily } from "./entityDetailsState";

export const generateFilterKey = (filters) => {
  return Object.entries(filters)
    .sort()
    .map(([key, value]) => `${key}=${value || ''}`)
    .join('&');
};

export const entityDetailsSelectorFamily = selectorFamily({
  key: 'entityDetailsSelectorFamily',
  get:
    (dropdownKey: string) =>
    async ({ get }) => {
      const state = get(entityDetailsStateAtomFamily(dropdownKey));
      // const entityFormMap= get(entityFormMappingAtom);
      const filters = state.filters;

      if (!filters.entityFormId) {
        return { data: [], totalCount: 0, fromCache: false };
      }
      // let parentId = null;
      // if(filters?.parentFormId && entityFormMap && entityFormMap?.[filters?.parentFormId]){
      //   parentId = entityFormMap?.[filters?.parentFormId];
      // }
      const filterKey = generateFilterKey(filters);
      if (state.cache[filterKey]) {
        return {
          data: state.cache[filterKey],
          totalCount: state.totalCountCache[filterKey],
          fromCache: true,
        };
      }

      try {
        const url = `${Apis.entityManagement}get-entity-list/?next_page=${filters.page}&entity_form_id=${filters.entityFormId}&limit=${filters.limit}&search=${filters.search || ''}`;
        const response = await APIService.get(url);

        if (!response?.data) {
          return { data: [], totalCount: 0, fromCache: false };
        }

        return {
          data: response.data.items || [],
          totalCount: response.data.total_count || 0,
          fromCache: false,
        };
      } catch (error) {
        console.error('Error fetching entity details:', error);
        return { data: [], totalCount: 0, fromCache: false };
      }
    },
});